import React from "react";
import {SkillItem,SkillHeader} from './skillsItem'

const professions = ['System Design','Web Developement','Network Security','MERN Stack Developer','Full Stack Engineer', "Frontend Engineer", "Linux OS", "Containerization", "Container Ochestration", "Micro Services", "Event Driven Developement"]

export const ProfessionalSkills = ({resume})=> {
    const technologies = resume?.technologies
    return (
        <section>
            <div class="card shadow border-0 rounded-4 mb-5">
                <div class="card-body p-5">

                    <div class="mb-5">
                        <SkillHeader iconClass="bi bi-tools" title="Professional Skills"/>
                        <div class="row row-cols-1 row-cols-md-3 mb-4">
                            {professions.map((v,i)=><SkillItem key={i} text={v}/>)}
                        </div>
                    </div>

                    <div class="mb-0">
                        <SkillHeader iconClass="bi bi-code-slash" title="Technologies / Languages"/>
                        <div class="row row-cols-1 row-cols-md-3 mb-4">
                            {technologies?.map(({name,url},i)=><SkillItem key={i} url={url} text={name}/>)}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}